<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5>{{modalTitle}}</h5>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl"
      >
        <div class="form-group row align-items-center" v-if="title">
          <label for="inputs_title" class="col-sm-3 mb-0">
            {{ $t("title") }}
          </label>
          <app-input
            id="inputs_title"
            class="col-sm-9"
            type="text"
            v-html="title"
            :read-only="true"
          />
        </div>
        <div class="form-group row align-items-center" v-if="start_date">
          <label for="start_date" class="col-sm-3 mb-0">
            {{ $t("start_date") }}
          </label>
          <app-input
            id="start_date"
            class="col-sm-9"
            type="text"
            v-html="start_date"
            :read-only="true"
          />
        </div>
        <div class="form-group row align-items-center" v-if="due_date">
          <label for="due_date" class="col-sm-3 mb-0">
            {{ $t("due_date") }}
          </label>
          <app-input
            id="due_date"
            class="col-sm-9"
            type="text"
            v-html="due_date"
            :read-only="true"
          />
        </div>
        <div class="form-group row align-items-center" v-if="inputs.name">
          <label for="inputs_title" class="col-sm-3 mb-0">
            {{ $t("assigned_to") }}
          </label>
          <app-input
            id="inputs_title"
            class="col-sm-9"
            type="text"
            v-html="inputs.name"
            :read-only="true"
          />
        </div>
        <div class="form-group row align-items-center" >
          <label for="inputs_title" class="col-sm-3 mb-0" v-if="inputs.from">
            {{ $t("assigned_from") }}
          </label>
          <app-input
            id="inputs_title"
            class="col-sm-9"
            type="text"
            v-html="inputs.from"
            :read-only="true"
          />
        </div>
        <div class="form-group row align-items-center" v-if="inputs.message">
          <label for="inputs_description" class="col-sm-3 mb-0">
            {{ $t("message") }}
          </label>
          <app-input
            id="inputs_description"
            class="col-sm-9"
            type="textarea"
            placeholder="Enter Description"
            v-html="inputs.message"
            :read-only="true"
          />
        </div>
        <div class="form-group row align-items-center" v-if="forms">
          <label for="inputs_forms" class="col-sm-3 mb-0">
            {{ $t("forms") }}
          </label>
          <app-input
            id="inputs_forms"
            class="col-sm-9"
            type="textarea"
            placeholder="Enter Description"
            v-html="forms"
            :read-only="true"
          />
        </div>

      </form>
    </template>
    <template slot="footer">
      <button class="btn btn-secondary" @click="closeModal">
        Close
      </button>
    </template>
  </app-modal>
</template>

<script>
import {FormMixin} from "../../../../core/mixins/form/FormMixin.js";
import {ModalMixin} from "../../../Mixins/ModalMixin";
import * as actions from "../../../Config/ApiUrl";
import {formatDateToLocal, onlyTime} from "../../../Helpers/Helpers";


export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    info: Object,
    type: String,
  },
  data() {
    return {
      addurl: '',
      title: '',
      description: '',
      start_date: '',
      start_time: '',
      due_date: '',
      end_time: '',
      forms: '',
      preloader: false,
      inputs: {},
      modalId: "notification-view-modal",
      modalTitle: this.$t("notification_view"),
    }
  },
  methods: {
    getTaskDetail() {

      this.inputs = this.info.data;
      this.inputs.date = formatDateToLocal(this.info.created_at)+' '+onlyTime(this.info.created_at);
      let split = this.info.data.message.split("<b>");
      // let from = split[2];    
      let from = this.info.assigned_from;  
      this.inputs.from = from;

      if(this.type == 'task'){
        this.task_id = this.info.data.url.split('?task=')[1];
        this.axiosGet(actions.NOTIFICATION_TASK_DETAIL_VIEW + "/" + this.task_id)
          .then((res)=>{
            this.title = res.data.title;
            this.description = res.data.description;
            this.start_date = res.data.start_date;
            this.start_time = res.data.start_time;
            this.due_date = res.data.due_date;
            this.end_time = res.data.end_time;
            this.end_time = res.data.end_time;
            this.end_time = res.data.end_time;
            this.forms = res.data.forms;
          })
          .catch((error)=>{
            console.log(error);
          })     
      }else{
        this.title = split[1];
      }

      // axiosGet(actions.NOTIFICATION_TASK_DETAIL_VIEW)
      //   .then((res) => {
      //     this.inputs = res.data;
      //   })
      //   .catch((error) => { 
          
      //   });
    },
  },

  mounted() {
    this.getTaskDetail();
  },
};
</script>
